// removed by extract-text-webpack-plugin
module.exports = {"linksModule":"_37nGi9aQVkyYgB3XA8TeTB","mainSubDiv":"_2tsN49n-RS2HDqAFsC1E0p","mainTitleDiv":"_2N8m_ES6tt4D9746yhGyWT","mainTitleContainer":"_3rCBx6BJpetOr_apnZuSJT","mainTitle":"mVN8ABQnr8xsDm2rm2DlD","bottomBorder":"_28kKR6dvNYE8O3D8lzktKj","link":"_1l7hJcDg5Ucpf-gZ-xfynj","text":"_2NM_kxToC79FFb_s2l3nLk","content":"_2KpFMhwd_B8-cdUpTg7dEh","ref":"_1G_MluUiYvnFLtFLKswhrk","textLink":"_1OLo4XB73JUq8L0M5ehMG7"};


//////////////////
// WEBPACK FOOTER
// ./components/links.scss
// module id = 1612
// module chunks = 0